<template>
  <div id="domain-update" v-if="detail.id > 0" @click="cancelLookup()">
    <form id="update-domain-form" @submit.prevent="submitForm">
      <div class="row">
        <div class="small-12 medium-5 columns">

          <fieldset class="fieldset">
            <legend>{{ 'Domain statuses'|t }}</legend>
            <label v-for="s in getStatusList()">
              <input type="checkbox" v-model="status" :value="s" />
              {{ s }}
            </label>
          </fieldset>

          <fieldset class="fieldset">
            <legend>{{ 'Contacts'|t }}</legend>
            <label v-for="c in getContactsList()">
              {{ c.label|t }}
              <span :class="lookup.name === c.field && lookup.working ? 'autocomplete-wrapper working' : 'autocomplete-wrapper'">
                <input type="text" v-model="$data[c.field]" @keyup.stop="lookupContact(c.field)" required="required" />
                <ul class="autocomplete-selection" v-if="lookupResults(c.field).length > 0">
                  <li class="autocomplete-item" v-for="res in lookupResults(c.field)" :key="res.id" @click.stop="setContact(res.contactid, c.field)">{{ contactLookupLabel(res)}}</li>
                </ul>
              </span>
            </label>
          </fieldset>

          <label>
            {{ 'Authentication password'|t }}
            <input type="text" v-model="auth" required="required" />
          </label>

          <label for="rgp">{{ 'Registry Grace Period'|t }}</label>
          <select id="rgp" v-model="rgp">
            <option value="">- {{ 'no change'|t }} -</option>
            <option value="request">Request</option>
            <option value="report" disabled="disabled">Report</option>
          </select>

          <label>
            {{ 'Name servers'|t }}
            <textarea v-model="ns" rows="5"></textarea>
          </label>

        </div>
      </div>

      <div class="row">
        <div class="small-12 medium-8 columns">
          <fieldset class="fieldset">
            <legend> {{ 'DNSSEC Mapping'|t }}</legend>

            <table v-for="(rec, k) in dns" class="unstriped">
              <tbody>
                <tr>
                  <td>DS Key Tag <a href="https://tools.ietf.org/html/rfc4034#section-5.1.1" target="_blank"><i class="icon icon-info"></i></a></td>
                  <td>
                    <input v-model="dns[k].ds_keytag" type="number" min="0" max="256" :disabled="dns[k]._existing ? 'disabled' : false" />
                  </td>
                </tr>
                <tr>
                  <td>DS Digest <a href="https://tools.ietf.org/html/rfc4034#section-5.1.4" target="_blank"><i class="icon icon-info"></i></a></td>
                  <td>
                    <input v-model="dns[k].ds_digest" type="text" pattern=".{40}" :disabled="dns[k]._existing ? 'disabled' : false" />
                  </td>
                </tr>
                <tr>
                  <td>Key Flags <a href="https://tools.ietf.org/html/rfc4034#section-2.1.1" target="_blank"><i class="icon icon-info"></i></a></td>
                  <td>
                    <select v-model="dns[k].key_flags" :disabled="dns[k]._existing ? 'disabled' : false">
                      <option value="0">0</option>
                      <option value="256">256</option>
                      <option value="257">257</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>Key Public Key</td>
                  <td>
                    <textarea v-model="dns[k].key_pubkey" :disabled="dns[k]._existing ? 'disabled' : false"></textarea>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <button @click.prevent.stop="removeDnsRecord(rec._key)" class="expanded alert button"><i class="icon icon-bin"></i> {{ 'Remove'|t }}</button>
                  </td>
                </tr>
              </tbody>
            </table>

            <button @click.prevent.stop="addDnsRecord" class="button"><i class="icon icon-plus"></i> {{ 'Add record'|t }}</button>

          </fieldset>
        </div>
      </div>

      <div class="row">
        <div class="small-12 medium-5 columns">
          <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'UpdateForm',
    props: {
      domain: {
        type: String,
        required: true,
      },
    },
    created() {
      let self = this;
      let sl = this.getStatusList();
      api.viewDomain(
        {domain: self.domain},
        data => {
          self.detail = data;
          self.status = data.status.filter(word => sl.indexOf(word) > -1);
          self.admin = data.admin_cid;
          self.tech = data.tech_cid;
          self.billing = data.billing_cid;
          self.registrant = data.owner_cid;
          self.auth = data.authid;
          self.ns = data.nameservers ? data.nameservers.join("\n") : "";

          if (data.extensions && data.extensions.dns_keys) {
            if (data.extensions.dns_keys.ds_data) {
              data.extensions.dns_keys.ds_data.forEach(dns => {
                let entry = {
                  _key: Math.random().toString(36).substring(2),
                  _existing: true,
                  key_flags: 0,
                  key_pubkey: null,
                  ds_keytag: dns.key_tag,
                  ds_digest: dns.digest_value,
                };
                if (dns.key_data) {
                  entry.key_flags = dns.key_data.flags;
                  entry.key_pubkey = dns.key_data.public_key;
                }
                self.dns.push(entry);
              })
            }
            if (data.extensions.dns_keys.key_data) {
              data.extensions.dns_keys.key_data.forEach(dns => {
                let entry = {
                  _key: Math.random().toString(36).substring(2),
                  _existing: true,
                  key_flags: dns.flags,
                  key_pubkey: dns.public_key,
                  ds_keytag: null,
                  ds_digest: null
                };
                self.dns.push(entry);
              })
            }
          }
        }
      );
    },
    data() {
      return {
        detail: {
          id: 0,
          domain: this.domain,
          extensions: {}
        },
        status: [],
        admin: "",
        tech: "",
        billing: "",
        registrant: "",
        auth: "",
        ns: "",
        dns: [],
        rgp: "",
        lookup: {
          delay: null,
          name: null,
          results: [],
          working: false
        }
      }
    },
    methods: {
      getStatusList() {
        return [
          'clientHold',
          'clientDeleteProhibited',
          'clientTransferProhibited',
          'clientUpdateProhibited',
          'clientRenewProhibited'
        ]
      },
      getContactsList() {
        return [
          { field: 'registrant', label: 'Registrant' },
          { field: 'admin', label: 'Admin' },
          { field: 'tech', label: 'Tech' },
          { field: 'billing', label: 'Billing' }
        ];
      },
      submitForm() {
        let request = {
          domain: this.domain
        };

        if (this.auth !== this.detail.authid) {
          request.auth_info = this.auth;
        }

        if (this.registrant !== this.detail.owner_cid) {
          request.registrant = this.registrant;
        }

        if (this.admin !== this.detail.admin_cid) {
          request.admin_contact = this.admin;
        }

        if (this.tech !== this.detail.tech_cid) {
          request.tech_contact = this.tech;
        }

        if (this.billing !== this.detail.billing_cid) {
          request.billing_contact = this.billing;
        }

        if (this.rgp !== "") {
          request.restore_rgp = this.rgp;
        }

        let add_ns = [];
        let rem_ns = [];
        let current_ns = this.detail.nameservers ? this.detail.nameservers : [];
        let provided_ns = this.ns.split("\n");
        for (let i in provided_ns) {
          if (provided_ns[i].length > 0 && current_ns.indexOf(provided_ns[i]) === -1) {
            add_ns.push(provided_ns[i])
          }
        }
        for (let i in current_ns) {
          if (current_ns[i].length > 0 && provided_ns.indexOf(current_ns[i]) === -1) {
            rem_ns.push(current_ns[i])
          }
        }
        if (add_ns.length > 0) {
          request.ns_add = add_ns;
        }
        if (rem_ns.length > 0) {
          request.ns_remove = rem_ns;
        }

        let status_add = [];
        let status_remove = [];
        let statuses = this.getStatusList();
        for (let i in statuses) {
          let s = statuses[i];
          if (this.status.indexOf(s) > -1 && this.detail.status.indexOf(s) === -1) {
            status_add.push(s);
          }
          if (this.status.indexOf(s) === -1 && this.detail.status.indexOf(s) > -1) {
            status_remove.push(s);
          }
        }
        if (status_add.length > 0) {
          request.status_add = status_add;
        }
        if (status_remove.length > 0) {
          request.status_remove = status_remove;
        }

        request.dnskey_remove_all = true;
        if (this.dns.length > 0) {
          let dnsRecords = JSON.parse(JSON.stringify(this.dns));
          let add_dns = [];
          for (let i in dnsRecords) {
            let rec = {
              key_flags: dnsRecords[i].key_flags === null ? 0 : parseInt(dnsRecords[i].key_flags),
              key_proto: 3,
              key_alg: 5,
              key_public_key: dnsRecords[i].key_pubkey === null ? "" : String(dnsRecords[i].key_pubkey),
              ds_key_tag: dnsRecords[i].ds_keytag === null ? 0 : parseInt(dnsRecords[i].ds_keytag),
              ds_alg: 5,
              ds_digest_type: 1,
              ds_digest_value: dnsRecords[i].ds_digest === null ? "" : String(dnsRecords[i].ds_digest)
            };

            if (rec.key_public_key !== "" || rec.ds_digest_value !== "") {
              add_dns.push(rec);
            }
          }
          if (add_dns.length > 0) {
            request.dnskey_add = add_dns;
          }
        }

        api.updateDomain(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Domain %s has been updated.",
              args: [data.domain]
            }, {root: true});
            router.push({name: 'domain.collection'});
          }
        );
      },
      addDnsRecord() {
        this.dns.push({
          _key: Math.random().toString(36).substring(2),
          _existing: false,
          key_flags: 0,
          key_pubkey: null,
          ds_keytag: null,
          ds_digest: null
        })
      },
      removeDnsRecord(id) {
        for (let k in this.dns) {
          if (this.dns[k]._key === id) {
            this.dns.splice(k, 1);
            return;
          }
        }
      },
      lookupContact(name) {
        this.cancelLookup();

        if (this[name].length <= 2) {
          return
        }

        this.lookup.name = name;
        this.lookup.working = true;

        this.lookup.delay = setTimeout(() => {
          let req = {
            contact: this[name]
          };
          api.lookupContact(
            req,
            data => {
              this.lookup.results = data.results;
              this.lookup.working = false;
              this.lookup.delay = null;
            },
            err => {
              this.lookup.results = [];
              this.lookup.name = null;
              this.lookup.working = false;
              this.lookup.delay = null;
            }
          )
        }, 500);

      },
      cancelLookup() {
        if (this.lookup.delay !== null) {
          clearTimeout(this.lookup.delay);
        }
        this.lookup.delay = null;
        this.lookup.results = [];
        this.lookup.name = null;
        this.lookup.working = false;
      },
      lookupResults(name) {
        return this.lookup.name === name ? this.lookup.results : [];
      },
      setContact(cid, name) {
        this[name] = cid;
        this.lookup.results = [];
        this.lookup.name = null;
      },
      contactLookupLabel(c) {
        let out = [c.contactid];

        if (c.name.length > 0) {
          out.push(c.name);
        }

        if (c.org.length > 0) {
          out.push(c.org);
        }

        return out.join(', ');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/domain/Update.vue